/* Klaily — product page: variant selection, gallery, quantity, AJAX add-to-cart.
   Hosted checkout + dynamic checkout button are Shopify-native; this only wires
   the storefront UX around them. */
(function () {
  'use strict';

  var root = document.querySelector('[data-product-mp]');
  if (!root) return;

  var variants = [];
  try { variants = JSON.parse(root.querySelector('[data-mp-variants]').textContent); } catch (e) {}

  var form = root.querySelector('.mp__form');
  var idInput = root.querySelector('[data-mp-id]');
  var priceNode = root.querySelector('[data-mp-price]');
  var stickyPrice = root.querySelector('[data-mp-sticky-price]');
  var addBtn = root.querySelector('[data-mp-add]');
  var addText = root.querySelector('[data-mp-add-text]');
  var stickyAdd = root.querySelector('[data-mp-sticky-add]');
  var optionInputs = root.querySelectorAll('[data-mp-option]');

  /* ---- Variant resolution ---- */
  function selectedOptions() {
    var byPos = {};
    optionInputs.forEach(function (input) {
      if (input.checked) byPos[input.getAttribute('data-mp-option')] = input.value;
    });
    return byPos;
  }

  function findVariant() {
    var sel = selectedOptions();
    var positions = Object.keys(sel);
    return variants.find(function (v) {
      return positions.every(function (p) { return v.options[p - 1] === sel[p]; });
    });
  }

  function renderPrice(v) {
    if (!priceNode) return;
    var html = '<span class="price-display' + (v.compare_at ? ' price-display--sale' : '') + '">' +
      '<span class="price">' + v.price + '</span>' +
      (v.compare_at ? '<s class="price__compare">' + v.compare_at + '</s>' : '') +
      '</span>';
    priceNode.innerHTML = html;
    if (stickyPrice) stickyPrice.textContent = v.price;
  }

  function setAvailability(v) {
    var avail = v && v.available;
    [addBtn, stickyAdd].forEach(function (b) { if (b) b.disabled = !avail; });
    if (addText) addText.textContent = avail ? 'Add to cart' : (v ? 'Sold out' : 'Unavailable');
    if (stickyAdd) stickyAdd.textContent = avail ? 'Add to cart' : (v ? 'Sold out' : 'Unavailable');
  }

  function showMedia(mediaId) {
    if (mediaId == null) return;
    root.querySelectorAll('.mp__slide').forEach(function (s) {
      s.classList.toggle('is-active', String(s.getAttribute('data-media-id')) === String(mediaId));
    });
    root.querySelectorAll('[data-mp-thumb]').forEach(function (t) {
      t.classList.toggle('is-active', String(t.getAttribute('data-mp-thumb')) === String(mediaId));
    });
  }

  function onOptionChange() {
    // reflect selected styling
    optionInputs.forEach(function (input) {
      var label = input.closest('.mp__swatch');
      if (label) label.classList.toggle('is-selected', input.checked);
    });
    var v = findVariant();
    if (!v) { setAvailability(null); return; }
    if (idInput) idInput.value = v.id;
    renderPrice(v);
    setAvailability(v);
    showMedia(v.media);
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);
    } catch (e) {}
  }

  optionInputs.forEach(function (input) { input.addEventListener('change', onOptionChange); });

  /* ---- Thumbnails ---- */
  root.querySelectorAll('[data-mp-thumb]').forEach(function (t) {
    t.addEventListener('click', function () { showMedia(t.getAttribute('data-mp-thumb')); });
  });

  /* ---- Quantity ---- */
  var qty = root.querySelector('[data-mp-qty]');
  var minus = root.querySelector('[data-qty-minus]');
  var plus = root.querySelector('[data-qty-plus]');
  if (minus) minus.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
  if (plus) plus.addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; });

  /* ---- AJAX add to cart ---- */
  if (form) {
    form.addEventListener('submit', function (e) {
      // Let the dynamic checkout (buy-it-now) button use its own flow.
      if (e.submitter && e.submitter.classList.contains('shopify-payment-button__button')) return;
      e.preventDefault();
      var btn = e.submitter || addBtn;
      var prev = addText ? addText.textContent : '';
      if (addText) addText.textContent = 'Adding…';
      if (btn) btn.disabled = true;

      var quantity = parseInt(qty ? qty.value : 1, 10) || 1;
      var done = function () {
        if (addText) addText.textContent = prev || 'Add to cart';
        if (btn) btn.disabled = false;
      };

      // Optimistic add: paint the line instantly from the matched variant's data,
      // then open + reconcile the drawer. klailyAddToCart opens the drawer itself,
      // so the panel is visible the moment the click lands — before the network.
      if (window.klailyAddToCart) {
        var vid = idInput.value;
        var v = variants.find(function (x) { return String(x.id) === String(vid); });
        var opt = null;
        if (v) {
          opt = {
            title: root.getAttribute('data-mp-title') || v.title,
            price: v.price_cents || 0,
            image: v.image || '',
            url: root.getAttribute('data-mp-url') || '',
            variantTitle: v.title === 'Default Title' ? '' : v.title
          };
        }
        window.klailyAddToCart({ id: vid, quantity: quantity }, opt).then(done, done);
      } else {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: idInput.value, quantity: quantity })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            if (window.klailyRefreshCart) window.klailyRefreshCart();
            if (window.klailyOpenCart) window.klailyOpenCart();
          })
          .catch(function () {})
          .finally(done);
      }
    });
  }

  /* ---- Sticky add-to-cart bar ----
     Shows when the main button scrolls out of view, but stays hidden while the
     reviews section is on screen so it never overlaps the review widget. */
  var sticky = root.querySelector('[data-mp-sticky]');
  if (sticky && addBtn && 'IntersectionObserver' in window) {
    var reviews = root.querySelector('.mp__reviews');
    var addInView = true;
    var reviewsInView = false;
    var syncSticky = function () { sticky.hidden = addInView || reviewsInView; };
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { addInView = en.isIntersecting; });
      syncSticky();
    }, { rootMargin: '0px 0px -10% 0px' }).observe(addBtn);
    if (reviews) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { reviewsInView = en.isIntersecting; });
        syncSticky();
      }, { rootMargin: '0px 0px -15% 0px' }).observe(reviews);
    }
  }
})();
